import PropTypes from 'prop-types';

const COLOR_SCHEMA = {
  negative: {
    bg: '#FFF',
    primary: '#FFF',
    white: '#FFF',
    strokeProps: {
      stroke: '#000',
      strokeWidth: 2
    }
  },
  blue: {
    bg: '#C9E3F7',
    primary: '#FFF',
    white: '#0a0d77',
    strokeProps: {
      stroke: null,
      strokeWidth: null
    }
  },
  orange: {
    bg: '#C9E3F7',
    primary: '#FB6E44',
    white: '#F4EFED',
    strokeProps: {
      stroke: null,
      strokeWidth: null
    }
  }
};

const ProfessionalLandlord = ({ color = 'orange' }) => {
  const schema = COLOR_SCHEMA[color] ?? COLOR_SCHEMA.orange;
  return (
    <svg viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="52" cy="52" r="52" fill={schema.bg} />
      <path
        d="M40.656 84L32.0439 75.5204L44.1009 63.6489L52.713 72.1285L40.656 84Z"
        fill={schema.primary}
        {...schema.strokeProps}
      />
      <path
        d="M28.8336 81.8137L20.2215 73.3341L48.3686 45.6198L56.9808 54.0994L28.8336 81.8137Z"
        fill={schema.white}
        {...schema.strokeProps}
      />
      <path
        d="M51.8133 25.2686C58.9478 18.2438 70.5151 18.2438 77.6496 25.2686C84.7841 32.2933 84.7841 43.6826 77.6496 50.7074C70.5151 57.7321 58.9478 57.7321 51.8133 50.7074C44.6788 43.6826 44.6788 32.2933 51.8133 25.2686Z"
        fill={schema.primary}
        {...schema.strokeProps}
      />
      <path
        d="M59.9873 33.6078C62.5257 31.1084 66.6413 31.1084 69.1797 33.6078C71.7181 36.1071 71.7181 40.1594 69.1797 42.6588C66.6413 45.1581 62.5257 45.1581 59.9873 42.6588C57.4489 40.1594 57.4489 36.1071 59.9873 33.6078Z"
        fill={schema.bg}
        {...schema.strokeProps}
      />
    </svg>
  );
};

ProfessionalLandlord.propTypes = {
  color: PropTypes.oneOf(['negative', 'blue', 'orange'])
};

export default ProfessionalLandlord;
